<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<h3 class="text-white">{{ $t('Upcoming Invoice') }}</h3>
		</template>
		<template slot="body">
			<div>
				<div class="text-center">
					<loading :active.sync="isFetching" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
						<template slot="after">
							<div class="absolute mt-1 ml-1 text-center">{{ $t('Getting upcoming invoice ...') }}</div>
						</template>
					</loading>
				</div>
				<div class="text-center mt-2">
					<img src="/img/logo/grafias_medium_ondark.png" alt="xls" width="150px"/>
				</div>
				<h5 class="text-center mt-2 mb-4" v-if="isOwnUpcomingInvoice">
					{{$t('No upcoming invoices for this transaction')}}
				</h5>
				<div v-if="invoiceItem">
					<!-- Title Head-->
					<div class="text-center mt-2">
						<h4>{{ $t('Receipt from ') }}{{invoiceItem && invoiceItem.account_name}}</h4>
					</div>
					<!-- line 2 (summary) -->
					<div class="row text-center mt-4">
						<div class="ml-4 pl-3"><h5>{{ $t('Summary') }}</h5></div>
					</div>
					<div class="invoice-summary">
							<!-- Package Name -->
							<div v-for="(item, index) in invoiceItem.lines.data" :key="index">
								<!-- date -->
								<div>{{convertTimestamp(item && item.period.start)}} - {{convertTimestamp(item && item.period.start)}}</div>
								<div class="d-flex justify-content-between mt-2">
									<div>{{item.description}}</div>
									<div>{{amountPaid(item.amount)}}</div>
								</div>
							</div>
						<mdDivider></mdDivider>
						<!-- Subtotal -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Subtotal')}}</div>
							<div>{{ amountPaid(invoiceItem && invoiceItem.subtotal)}}</div>
						</div>
						<!-- Total Discount Amount -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Total Discount')}}</div>
							<div v-if="invoiceItem && invoiceItem.total_discount_amounts.length >= 1">
								<div v-for="(itemDiscount, indexDiscount) in invoiceItem.total_discount_amounts" :key="indexDiscount">
									<div>{{ amountPaid(itemDiscount.amount) }} </div>
								</div>
							</div>
							<div v-else>
								<div> $0 </div>
							</div>
						</div>
						<!-- Total -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Total')}}</div>
							<div>{{ amountPaid(invoiceItem && invoiceItem.total)}}</div>
						</div>
						<!-- Amount Due -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Amount Due')}}</div>
							<div>{{ amountPaid(invoiceItem && invoiceItem.amount_due)}}</div>
						</div>
					</div>
					<!-- generate pdf -->
					<div>
						<vue-html2pdf
							:show-layout="false"
							:float-layout="true"
							:enable-download="true"
							:paginate-elements-by-height="1100"
							:filename=nameInvoicePdf
							:pdf-quality="2"
							:manual-pagination="false"
							pdf-format="a4"
							pdf-orientation="portrait"
							pdf-content-width="800px"
							ref="html2Pdf"
						>
							<section slot="pdf-content" class="invoice-body">
								<section class="pdf-item text-black  p-5em">
									<!-- line 1 title -->
									<div class="d-flex justify-content-between">
										<div>
											<img src="/img/logo/grafias_large_onwhite.png" alt="xls" width="200px"/>
											<!-- <h2 class="text-navy">Grafias</h2> -->
										</div>
										<div class="text-grey">
											<h2>Upcoming Invoice</h2>
										</div>
									</div>
									<!-- line 2 title -->
									<div class="d-flex justify-content-between">
										<div class="text-grey pt-3">
											<div class="text-navy-light">SuperSource, Inc</div>
											<div class="text-navy-light">8 The Green</div>
											<div class="text-navy-light">Suite 12214</div>
											<div class="text-navy-light">Dover, DE 19901</div>
											<div class="text-navy-light">United States</div>
											<div class="text-navy-light">1 (302) 289-8007</div>
											<div class="text-navy">billing@grafi.as</div>
										</div>
										<div class="text-black">
											<div class="d-flex justify-content-between">
												<label class="mr-2 text-navy-light">Date of issue</label>
												<label class="text-navy">{{convertTimestamp(invoiceItem && invoiceItem.created)}}</label>
											</div>
										</div>
									</div>
									<!-- line 3 bill to-->
									<div class="d-flex justify-content-between">
										<div class="text-grey mt-7">
											<h5 class="text-navy">Bill to</h5>
											<h5 class="mb-0 text-navy-light">{{invoiceItem && invoiceItem.customer_name}}</h5>
											<h5 class="mb-0 text-navy-light">{{invoiceItem && invoiceItem.customer_email}}</h5>
										</div>
									</div>
									<!-- line 4 total payment -->
									<div class="d-flex">
										<div class="d-flex text-grey mt-7 mb-5">
											<h2 class="text-navy">{{amountPaid(invoiceItem && invoiceItem.total)}}</h2><h2 v-if="invoiceItem && invoiceItem.due_date">due {{convertTimestamp(invoiceItem && invoiceItem.due_date)}}</h2>
										</div>
									</div>
									<!-- table -->
									<table class="table mb-4 bg-white-tb table-striped-grey mb-25 text-small">
									<thead>
										<tr class="border-bottom">
											<th width="55%" class="fs-13px">{{ $t('Description') }}</th>
											<th class="fs-13px">{{ $t('Qty') }}</th>
											<th class="fs-13px">{{ $t('Unit Price') }}</th>
											<th class="fs-13px">{{ $t('Amount') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr class="border-bottom"
											v-for="(item, index) in invoiceItem.lines.data" :key="index">
											<td>{{ item.description }}</td>
											<td>{{ item.quantity }}</td>
											<td>{{ amountPaid(item.price.unit_amount) }}</td>
											<td>{{ amountPaid(item.price.unit_amount * item.quantity) }}</td>
										</tr>
										<tr>
											<td class="bg-white"></td><td class="bg-white"></td>
											<td class="bg-navy-light border-bottom">Subtotal</td>
											<td class="bg-navy-light border-bottom">{{ amountPaid(invoiceItem && invoiceItem.subtotal) }}</td>
										</tr>
										<tr v-if="invoiceItem && invoiceItem.total_discount_amounts.length > 0">
											<td class="bg-white"></td>
											<td class="bg-white"></td>
											<td class="bg-navy-light border-bottom">Total Discount</td>
											<td class="bg-navy-light border-bottom">{{ amountPaid(invoiceItem && invoiceItem.total_discount_amounts) }}</td>
										</tr>
										<tr>
											<td class="bg-white"></td><td class="bg-white"></td>
											<td class="bg-amount-paid">Amount Due</td>
											<td class="bg-amount-paid">{{ amountPaid(invoiceItem && invoiceItem.amount_due) }}</td>
										</tr>
									</tbody>
								</table>
								<div><hr></div>
								<div style="position: absoulte; bottom: 0;">Terms and conditions apply <a class="text-navy" href="https://grafi.as/terms-and-condition/">https://grafi.as/terms-and-condition/</a></div>
								<span class="text-navy mr-1">Questions?</span><span>Contact SuperSource, Inc at <span class="text-navy mr-1">billing@grafi.as</span> or call at <span class="text-navy mr-1">+1 (302) 289-8007</span>.</span>
								</section>
							</section>
						</vue-html2pdf>
					</div>
					<div @click="generateReport()" class="text-primary ml-3 pl-2 pointer mb-3">Download invoice as PDF</div>
					<!-- close -->
					<!-- <div class="text-center">
						<button @click="close"	class="btn btn-submit btn-primary mt-3">
							{{ $t('OK') }}
						</button>
					</div> -->
				</div>
			</div>
		</template>
	</modal>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import dayjs from 'dayjs';
import Loading from 'vue-loading-overlay';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import transactionsApi from '@/api/transactions';

export default {
	name: 'InvoiceUpcomingModal',
	props: {
		data: {
		},
		user: {
		},
		mineId: {
		},
	},
	components: {
		Modal,
		Loading,
		VueHtml2pdf,
	},
	data() {
		return {
			invoiceItem: null,
			isFetching: false,
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			nameInvoicePdf: '',
			isOwnUpcomingInvoice: false,
		};
	},
	methods: {
		generateReport() {
			this.$refs.html2Pdf.generatePdf();
		},
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				const invoiceItem = response.data;
				// eslint-disable-next-line
				if (invoiceItem.hasOwnProperty('account_country')) {
					this.invoiceItem = invoiceItem;
					this.nameInvoicePdf = `${this.invoiceItem.customer_name}-Upcoming Invoice`;
					this.isOwnUpcomingInvoice = false;
				} else {
					this.isOwnUpcomingInvoice = true;
				}
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isFetching = false;
			};
			if (this.data) {
				transactionsApi.getUpcomingInvoice(this.data.user_id, callback, errorCallback);
			} else if (this.mineId) {
				transactionsApi.getUpcomingInvoice(this.mineId, callback, errorCallback);
			}
		},
		amountPaid(item) {
			if (item === 0) return '$0';
			const itemString = item.toString();
			const index = itemString.indexOf('-');
			if (index !== -1) {
				const removeMin = itemString.substring(1);
				const result = `${removeMin.slice(0, -2)}.${removeMin.slice(-2)}`;
				return `-$${result}`;
			}
			const result = `${itemString.slice(0, -2)}.${itemString.slice(-2)}`;
			return `$${result}`;
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
		},
		reset() {
		},
		convertTimestamp(time) {
			const date = new Date(time * 1000);
			return dayjs(date).format('MMM DD, YYYY');
		},
	},
	computed: {
	},
	created() {
		this.initData();
		this.fetch();
	},
};
</script>
